export enum EnrollmentRecapSliceNames {
    ENROLLMENT_RECAP = 'enrollmentRecap',
    FETCH_ENROLLMENT_RECAP = 'enrollmentRecap/fetchEnrollmentRecap'
}

export type EnrollmentRecapItem = {
    loading: boolean
    error: string
    hasLoadedOnce: boolean
    sourceCounts: Record<string, number>
}

export type EnrollmentRecapState = Record<string, EnrollmentRecapItem>
